const DefaultOptions = {
  showSearchOptions: false
};
export { DefaultOptions };
